// When a screen breaks: say so in plain words, tell SSG automatically, and give
// a way on (try again, go home, or tell us what you were doing). Never a blank page.
import { useQuery } from "@tanstack/react-query";
import { type ErrorComponentProps, Link, useRouter } from "@tanstack/react-router";
import { useEffect } from "react";
import { openFeedback } from "../components/feedback-button.tsx";
import { Button, Page, quietClass } from "../components/ui.tsx";
import { meQuery } from "../lib/api.ts";
import { reportProblem } from "../lib/capture.ts";

export function Crash({ error, reset }: ErrorComponentProps) {
	const router = useRouter();
	const { data: me } = useQuery(meQuery);
	useEffect(() => reportProblem(error), [error]);
	return (
		<Page title="Something went wrong on this page" intro="It's not something you did. We've been told automatically.">
			<p className="mb-5">Trying again usually works. Anything you'd already saved is safe.</p>
			<div className="flex flex-wrap items-center gap-3">
				<Button
					onClick={() => {
						reset();
						void router.invalidate();
					}}
				>
					Try again
				</Button>
				{me ? (
					<Button variant="secondary" onClick={() => openFeedback("bug")}>
						Tell us what you were doing
					</Button>
				) : null}
				<Link to="/" className={quietClass}>
					Go to Home
				</Link>
			</div>
		</Page>
	);
}
